import * as React from "react";
const SvgMessage = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 24 24", style: {
  enableBackground: "new 0 0 24 24"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16,8h6v10.7h-2v3.2h-0.5l-3.2-3.2H8v-6h-6V2H16V8z M2.9,12H8V8h7.1V2.8H2.9V12z M21.2,18V8.8H8.8V18h7.8l2.6,2.6V18 L21.2,18z" }));
export default SvgMessage;
